import { useState } from "react";

import Dropdown from "react-bootstrap/lib/Dropdown";
import MenuItem from "react-bootstrap/lib/MenuItem";
import DropdownMenu from "react-bootstrap/lib/DropdownMenu";
import DropdownToggle from "react-bootstrap/lib/DropdownToggle";

import { TextField } from "../input/bs-input";

interface DropdownProps {
  id?: string;
  initValue?: number;
  customClass?: string;
  onChange: Function;
  placeHolder: string;
  options: Array<any>;
  renderLabel: Function;
  searchParams: Array<string>;
}

const emptyObj = {};
const DD_MENU_ID = "dropdownMenu";

const BsDropdown = ({
  id = "custom-dropdown",
  initValue = 0,
  onChange = () => {},
  placeHolder = "",
  options = [],
  customClass = "",
  renderLabel,
  searchParams = [],
}: DropdownProps) => {
  const [value, setValue] = useState(initValue);
  const [search, setSearch] = useState("");

  const onToggle = (open) => {
    if (!open) {
      document.getElementById(DD_MENU_ID).scrollTop = 0;
    }
  };

  const onSelect = (idx) => {
    const selectedVal = options[idx];
    setValue(idx);
    onChange(selectedVal);
  };

  const selectedOption = options[value];

  const hasRenderLabel = typeof renderLabel === "function";
  const headValue = hasRenderLabel
    ? renderLabel({ active: true, option: selectedOption })
    : selectedOption?.label || placeHolder;

  const searchRegex = new RegExp(search, "gi");

  return (
    <Dropdown id={id} onToggle={onToggle} onSelect={onSelect} className={customClass}>
      <DropdownToggle>{headValue}</DropdownToggle>
      <DropdownMenu id={DD_MENU_ID}>
        <TextField
          placeholder="Search"
          prefix={<span className="icon icon-search"></span>}
          value={search}
          onChange={setSearch}
          autoFocus
          classes={emptyObj}
        />
        {options.map((option, idx) => {
          const { label } = option;
          const props = {
            active: idx == value,
            eventKey: idx,
            option,
          };
          const showOption = search
            ? searchParams.find((key) => searchRegex.test(option[key]))
            : true;
          return showOption ? (
            <MenuItem key={`dropdown-item-${idx}`} {...props}>
              {hasRenderLabel ? renderLabel(props) : label}
            </MenuItem>
          ) : null;
        })}
      </DropdownMenu>
    </Dropdown>
  );
};

export default BsDropdown;
